import React, { PropsWithChildren } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { When } from 'react-if';
import { QuestionmarkSmallCircleColorIcon } from '@zep/icons';
import { Input, InputTextLengthLabel, Stack, TextField, Toggle, Tooltip } from '@zep/ui';
import { isMobile } from '@zep/utils/device';
import { CreateSpaceSchemaType, SpaceSchemaSpec } from '../schema';
interface SpaceSettingsFormProps {
  disabled?: boolean;
  className?: string;
}
export const SpaceSettingsForm = ({
  disabled = false,
  className
}: SpaceSettingsFormProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    register,
    watch,
    setValue
  } = useFormContext<CreateSpaceSchemaType>();
  const name = watch('name');
  const enableRtc = watch('enableRtc');
  const toggleRtc = (event: React.FormEvent<HTMLInputElement>) => {
    setValue('enableRtc', event.currentTarget.checked);
  };
  return <Stack gap={24} className={className} data-sentry-element="Stack" data-sentry-component="SpaceSettingsForm" data-sentry-source-file="SpaceSettingsForm.tsx">
      <TextField label={<TextFiledLabel>
            <span className="text-subtitle font-semibold text-gray-900">
              {t('common:createSpaceModal.nameLabel')}
            </span>
          </TextFiledLabel>} rightSlot={<InputTextLengthLabel inputLength={name.length} maxInputLength={SpaceSchemaSpec.name.maxLength} />} data-sentry-element="TextField" data-sentry-source-file="SpaceSettingsForm.tsx">
        <Input size={'md'} isFullWidth style={{
        fontSize: '16px'
      }} {...register('name')} placeholder={t('common:createSpaceModal.namePlaceHolder')} maxLength={SpaceSchemaSpec.name.maxLength} disabled={disabled} data-sentry-element="Input" data-sentry-source-file="SpaceSettingsForm.tsx" />
      </TextField>
      <Toggle isFullWidth onChange={toggleRtc} checked={enableRtc} label={<Stack direction={'row'} gap={4} style={{
      alignItems: 'center'
    }}>
            <span className="text-subtitle font-semibold text-gray-900">
              {t('common:spaces.create.ad55123c')}
            </span>
            <When condition={!isMobile()}>
              <Tooltip placement="top" tooltipClassName="max-w-[300px] break-words" title={t('common:spaces.create.076f8fa6')}>
                <QuestionmarkSmallCircleColorIcon width={24} height={24} />
              </Tooltip>
            </When>
          </Stack>} labelPlacement={'right'} disabled={disabled} data-sentry-element="Toggle" data-sentry-source-file="SpaceSettingsForm.tsx" />
    </Stack>;
};
const TextFiledLabel = (prop: PropsWithChildren) => <span className="text-subtitle font-semibold" data-sentry-component="TextFiledLabel" data-sentry-source-file="SpaceSettingsForm.tsx">{prop.children}</span>;